import styled, { keyframes } from 'styled-components';
import { Box } from '../Box';

export const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerWrap = styled(Box)
    .withConfig({ displayName: 'SpinnerWrap' })
    .attrs((props) => ({
        ...props,
    }))<{ size: number }>`
    display: inline-block;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
`;

export const SpinnerSvg = styled.svg.withConfig({ displayName: 'SpinnerSvg' })<{ size: number }>`
    display: block;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    animation: ${rotate} 1s linear infinite;
`;

export const SpinnerCircle = styled.circle.withConfig({ displayName: 'SpinnerCircle' })<{
    color: string;
}>`
    cx: 20px;
    cy: 20px;
    r: 16px;
    stroke: ${({ color }) => color};
    stroke-width: 4px;
    stroke-linecap: round;
    stroke-dasharray: 80px;
    stroke-dashoffset: 60px;
    fill: none;
`;
